import React, { useState, useRef, useEffect } from "react";
import styles from "../../styles/components/DashboardFilters.module.css";
import { ReactComponent as DownIcon } from "../../assets/icons/down.svg";
import DateRangePicker from "./DateRangePicker";
import { useAuth } from "../../contexts/AuthContext";
import { useLeadContext } from "../../contexts/LeadContext";

function MultiSelectDropdown({ label, allLabel, options, selected, onChange }) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) setOpen(false);
    }
    if (open) document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, [open]);

  const isAll = selected.length === 0 || selected.length === options.length;

  function toggle(id) {
    const next = selected.includes(id)
      ? selected.filter(s => s !== id)
      : [...selected, id];

    onChange(next.length === options.length ? [] : next);
  }

  const displayLabel = isAll
    ? allLabel
    : selected.length === 1
      ? options.find(o => o.id === selected[0])?.label ?? allLabel
      : `${selected.length} ${label.toLowerCase()}`;

  return (
    <div className={styles.wrapper} ref={wrapperRef}>
      <button
        type="button"
        className={[styles.trigger, open ? styles.triggerOpen : ""].join(" ")}
        onClick={() => setOpen(o => !o)}
      >
        <span>{displayLabel}</span>
        <DownIcon className={[styles.chevron, open ? styles.chevronUp : ""].join(" ")} />
      </button>

      {open && (
        <div className={styles.menu}>

          <button
            type="button"
            className={[styles.option, isAll ? styles.optionActive : ""].join(" ")}
            onClick={() => { onChange([]); setOpen(false); }}
          >
            {allLabel}
          </button>

          <div className={styles.menuDivider} />

          {options.map(opt => (
            <button
              key={opt.id}
              type="button"
              className={[styles.option, !isAll && selected.includes(opt.id) ? styles.optionActive : ""].join(" ")}
              onClick={() => toggle(opt.id)}
            >
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default function DashboardFilters({ onAccountChange, onTypeChange, onDateChange }) {
  const { accounts: ctxAccounts } = useAuth();
  const { types: ctxTypes } = useLeadContext();

  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);

  const accountOptions = (ctxAccounts ?? []).map(a => ({
    id: String(a.id),
    label: a.name,
  }));

  const typeOptions = (ctxTypes ?? []).map(t => ({
    id: String(t.id),
    label: t.name,
  }));

  function handleAccountChange(next) {
    setSelectedAccounts(next);
    onAccountChange?.(next);
  }

  function handleTypeChange(next) {
    setSelectedTypes(next);
    onTypeChange?.(next);
  }

  return (
    <div className={styles.filters}>
      <MultiSelectDropdown
        label="Cuentas"
        allLabel="Todas las cuentas"
        options={accountOptions}
        selected={selectedAccounts}
        onChange={handleAccountChange}
      />
      <MultiSelectDropdown
        label="Tipos"
        allLabel="Todos los tipos"
        options={typeOptions}
        selected={selectedTypes}
        onChange={handleTypeChange}
      />
      <DateRangePicker onChange={onDateChange} />
    </div>
  );
}
